module.exports = __webpack_public_path__ + "static/img/qiantai@3x.be25ddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/A2/qiantai@3x.png
// module id = qHiK
// module chunks = 0